import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Sidebar, Menu } from 'semantic-ui-react'
import SideBarLeft from 'Components/SideBarLeft/SideBarLeft'
import styles from './SideBarsStyles';

class SideBars extends PureComponent {
  render () {
    const { matchProps } = this.props
    return (
      <Sidebar
        as={Menu}
        animation='overlay'
        vertical
        className={styles.leftSideBar}
        visible={this.props.leftSideBarVisible}>
          <SideBarLeft {...matchProps} />
      </Sidebar>
    )
  }
}

const mapStateToProps = (state) => ({
  leftSideBarVisible: state.selections.leftSideBarVisible
})

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(SideBars)



// WEBPACK FOOTER //
// ./src/Components/SideBars.js